import type { Category } from './types';

export const CATEGORY_LABELS: Record<Category, string> = {
  push: 'Push',
  row: 'Pull',
  hinge: 'Hinge',
  squat: 'Squat',
};

/** Display order used everywhere categories are listed. */
export const CATEGORY_ORDER: readonly Category[] = ['push', 'row', 'hinge', 'squat'] as const;

/** The competition (reference) lift name shown for each category. */
export const COMPETITION_LIFT_NAMES: Record<Category, string> = {
  push: 'Bench Press',
  row: 'Barbell Row',
  hinge: 'Deadlift',
  squat: 'Back Squat',
};

/**
 * ⚠️  DO NOT REMOVE, and do not assume the database has been cleaned up.
 *
 * The deadlift category used to be stored as `'pull'`. It is now stored as
 * `'hinge'` and displayed "Hinge", while the separate upper-body category is
 * stored as `'row'` and displayed "Pull".
 *
 * Existing documents in Firestore were deliberately NOT migrated - there are
 * live workouts with `category: 'pull'` meaning deadlift, and there always will
 * be unless someone runs scripts/migrate-pull-to-hinge.mjs. New workouts are
 * written as `'hinge'`, so the collection holds a mix of both.
 *
 * Deleting this constant or normalizeCategory() would silently drop every
 * pre-rename deadlift out of the Hinge category. It is only safe to remove once
 * a query for `category == 'pull'` returns zero documents.
 */
export const LEGACY_HINGE_CATEGORY = 'pull';

/**
 * Translates a raw stored category into a canonical one.
 *
 * Call this wherever workout data enters the app, so nothing downstream needs to
 * know about legacy values. Unrecognised values pass through unchanged and are
 * ignored by the summary builder rather than crashing it.
 */
export function normalizeCategory(raw: string): Category {
  return (raw === LEGACY_HINGE_CATEGORY ? 'hinge' : raw) as Category;
}
